// extracted by mini-css-extract-plugin
export default {"container":"_8bf8db11","results":"_d86eeccc","searchSuggestions":"_3d456be7"};